import { useState } from "react";
import emailjs from "@emailjs/browser";
import Seo from "../components/Seo";
import { site } from "../config/site";

const EJS_SERVICE  = "service_tudpfug";
const EJS_TEMPLATE = "template_anrsy8b";
const EJS_KEY      = "HMwNInUjZxvFkkoqM";

export default function Kontakt() {
  const [status, setStatus] = useState("idle");

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus("sending");
    const fd = new FormData(e.target);
    try {
      await emailjs.send(
        EJS_SERVICE,
        EJS_TEMPLATE,
        {
          name:      fd.get("name"),
          email:     fd.get("email"),
          betreff:   fd.get("betreff"),
          nachricht: fd.get("nachricht"),
        },
        EJS_KEY
      );
      setStatus("success");
      e.target.reset();
    } catch (err) {
      console.error("EmailJS:", err);
      setStatus("error");
    }
  }

  return (
    <>
      <Seo title="Kontakt" path="/kontakt" description="Kontaktiere das Team Sempachersee — wir freuen uns auf deine Nachricht." />

      <div className="grid md:grid-cols-2 min-h-[70vh]">
        {/* Linke Seite: Infos */}
        <div className="bg-primary text-white px-8 md:px-14 py-16 flex flex-col justify-between">
          <div>
            <p className="text-accent font-bold uppercase tracking-widest text-xs mb-3">Wir sind erreichbar</p>
            <h1 className="text-5xl md:text-6xl font-extrabold uppercase leading-none">Kontakt</h1>
            <p className="mt-6 text-white/80 text-lg max-w-sm">
              Fragen zum Sponsoring oder zur Gruppierung? Wir melden uns schnellstmöglich.
            </p>
            <div className="mt-10 space-y-4">
              {/* Adresse */}
              <div className="flex items-start gap-3">
                <svg className="h-5 w-5 text-accent flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <p className="text-white/90 text-sm leading-relaxed">
                  {site.contact.address.split(', ').map((line, i) => (
                    <span key={i} className="block">{line}</span>
                  ))}
                </p>
              </div>
              {/* Telefon */}
              <div className="flex items-center gap-3">
                <svg className="h-5 w-5 text-accent flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a href={`tel:${site.contact.phone}`} className="text-white/90 text-sm hover:text-white transition-colors">
                  {site.contact.phone}
                </a>
              </div>
              {/* Mail */}
              <div className="flex items-center gap-3">
                <svg className="h-5 w-5 text-accent flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href={`mailto:${site.contact.email}`} className="text-white/90 text-sm hover:text-white transition-colors">
                  {site.contact.email}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Rechte Seite: Formular */}
        <div className="px-8 md:px-14 py-16 bg-white flex items-center">
          {status === "success" ? (
            <div className="w-full max-w-md">
              <div className="h-1 w-10 bg-accent mb-6" />
              <h2 className="text-2xl font-extrabold uppercase">Danke!</h2>
              <p className="mt-2 text-dark/70">Deine Nachricht wurde gesendet. Wir melden uns bald.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="w-full max-w-md space-y-6">
              <div className="h-1 w-10 bg-accent" />
              <h2 className="text-2xl font-extrabold uppercase">Nachricht senden</h2>

              <div>
                <label className="block text-xs font-bold uppercase tracking-wide text-dark/50 mb-1">Name *</label>
                <input
                  name="name"
                  required
                  placeholder="Dein Name"
                  className="w-full border-b-2 border-dark/20 py-2 outline-none focus:border-primary text-sm transition-colors"
                />
              </div>
              <div>
                <label className="block text-xs font-bold uppercase tracking-wide text-dark/50 mb-1">E-Mail *</label>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="deine@mail.ch"
                  className="w-full border-b-2 border-dark/20 py-2 outline-none focus:border-primary text-sm transition-colors"
                />
              </div>
              <div>
                <label className="block text-xs font-bold uppercase tracking-wide text-dark/50 mb-1">Betreff</label>
                <input
                  name="betreff"
                  placeholder="Sponsoring / Allgemein / ..."
                  className="w-full border-b-2 border-dark/20 py-2 outline-none focus:border-primary text-sm transition-colors"
                />
              </div>
              <div>
                <label className="block text-xs font-bold uppercase tracking-wide text-dark/50 mb-1">Nachricht *</label>
                <textarea
                  name="nachricht"
                  required
                  rows="4"
                  placeholder="Deine Nachricht..."
                  className="w-full border-b-2 border-dark/20 py-2 outline-none focus:border-primary text-sm transition-colors resize-none"
                />
              </div>

              <button
                type="submit"
                disabled={status === "sending"}
                className="inline-flex items-center gap-2 bg-primary px-8 py-3 font-bold text-white uppercase tracking-wide text-sm hover:bg-accent transition-colors disabled:opacity-60"
              >
                {status === "sending" ? "Senden…" : "Absenden"}
                {status !== "sending" && (
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                  </svg>
                )}
              </button>
              {status === "error" && (
                <p className="text-red-600 text-sm">Etwas ging schief. Bitte erneut versuchen oder direkt per Mail schreiben.</p>
              )}
            </form>
          )}
        </div>
      </div>
    </>
  );
}
